import React, { useState } from "react";
import './nav.css';
import {AiFillHome} from 'react-icons/ai';
import {FaUserAlt} from 'react-icons/fa';
import {BiNotepad} from 'react-icons/bi'
import {GoMortarBoard} from 'react-icons/go';
import {AiFillPhone} from 'react-icons/ai';
import {BiBook} from 'react-icons/bi';


function Nav() {
    const [activeNav, setNav] = useState('#');
    return(
        <nav id="mainNav">
            <a href="#" 
            className={activeNav === '#' ? 'active' : ''}
            onClick={() => setNav ('#')}><AiFillHome /></a>

            {/* <a href="#about"
            className={activeNav === '#about' ? 'active' : ''}
            onClick={() => setNav('#about')}><FaUserAlt /></a> */}

            <a href="#projects" 
            className={activeNav === '#projects' ? 'active' : ''}
            onClick={() => setNav('#projects')}><BiNotepad /></a>

            <a href="#education" 
            className={activeNav === '#education' ? 'active' : ''}
            onClick={() => setNav('#education')}><GoMortarBoard /></a>

            <a href="#experience"
            className={activeNav === '#experience' ? 'active' : ''}
            onClick={() => setNav('#experience')}><BiBook /></a>

            <a href="#contact"
            className={activeNav === '#contact' ? 'active' : ''}
            onClick={() => setNav('#contact')}><AiFillPhone /></a>

        </nav>
    )
}

export default Nav;